module.exports = __webpack_public_path__ + "img/horizontal_6_7_9006.74d0fdd9.png";